import Image from "next/image";
import React from "react";

interface Props {
    method: string;
    width?: number;
}

export const PaymentMethodIcon = ({ method, width = 50 }: Props) => {
    return method ? (
        <Image
            src={`/images/mollie/payment_methods/${method.toLowerCase()}.svg`}
            layout="intrinsic"
            width={width}
            height={width * 0.75}
            alt={`Mollie Payment Method Icon for ${method}`}
        />
    ) : (
        <span />
    );
};
